import { VCardTitle } from "vuetify/lib";

export default {
	name: "KDataTableHeader",

	props: {
		hasErrors: Boolean
	},

	render() {
		return <VCardTitle class={{
			"grey darken-4": !this.hasErrors,
			"white--text text-subtitle-1": true,
			error: this.hasErrors
		}}>
			{this.$slots.default}
		</VCardTitle>;
	}
};
